import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueWaypoint from 'vue-waypoint'
// import './registerServiceWorker'
import VueGtm from '@gtm-support/vue2-gtm'

// "@vue/cli-plugin-pwa": "^4.5.6",

Vue.config.productionTip = false

Vue.use(VueWaypoint)

Vue.use(VueGtm, {
  id: 'GTM-PZQ2JJD',
  vueRouter: router
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
